module.exports = __webpack_public_path__ + "static/media/EmptyYellowstar.7880b8fa.svg";